import React, { useState } from "react";
import {
  AppBar,
  Avatar,
  MenuItem,
  Toolbar,
  IconButton,
  Menu,
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
  changeOrg,
} from "../../context/LayoutContext";
import { useUserDispatch, signOut } from "../../context/UserContext";
import { getCurrentOrg } from "../../utils/functions";

export default function Header(props) {
  const org = new URLSearchParams(props.history.location.search).get("org");
  const fullOrg = getCurrentOrg(org);
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [profileMenu, setProfileMenu] = useState(null);

  const [userOrgs] = useState(JSON.parse(localStorage.getItem("user_orgs")));

  async function setCurrentOrg(e) {
    var id = e.getAttribute("id");
    let currentOrg = userOrgs[id];

    localStorage.setItem("current_org", JSON.stringify(currentOrg));
    changeOrg(layoutDispatch, userOrgs[id], props.history);
    setProfileMenu(false);
  }

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButtonSandwich,
            classes.headerMenuButtonCollapse,
          )}
        >
          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        <Avatar src={localStorage.getItem("user_avatar")} />

        <Typography variant="h6" weight="medium" className={classes.logotype}>
          Welcome, {localStorage.getItem("user")}!
        </Typography>
        <div className={classes.grow} />
        <Avatar
          src={fullOrg.avatar_url}
          onClick={(e) => setProfileMenu(e.currentTarget)}
        />

        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          {userOrgs.map((o, i) => {
            return (
              <MenuItem
                key={i}
                id={i}
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
                onClick={(e) => setCurrentOrg(e.currentTarget)}
              >
                <Avatar
                  src={o.avatar_url}
                  className={classes.profileMenuIcon}
                />{" "}
                {o.login}
              </MenuItem>
            );
          })}
          <div className={classes.profileMenuUser}>
            <Typography
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => signOut(userDispatch, props.history)}
            >
              Sign Out
            </Typography>
          </div>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
